// oxlint-disable-next-line no-restricted-syntax
export const NATIVE_CHAIN_ID = 'NATIVE'
